export const urls = {
  GET_DATA: 'DokNarudzbine/vrati_dok_narudzbine',
  GET_SERVISNE_ZAHTEVE_FILTER:
    'DokServisniZahtevi/servisni_zahtevi_vrati_sa_filterom',
  GET_STATUSI_COMBO: 'Combo/vrati_statuse_servisnog_zahteva',
  GET_STATUS_DOK: 'Combo/vrati_statuse_dok_narudzbine_filter',
  PREGLED_NARUDZBINE: 'DokNarudzbine/narudzbine_pregled_dokumenata_glavni',
};
